<template>
  <service-view
    :pictures="pictures"
    :serviceTitle="serviceTitle"
    :serviceDescription="serviceDescription"
    :paintingingActive="'active'"
  />
</template>
<script>
import ServiceView from "./ServiceView";
export default {
  name: "paiting",
  components: {
    ServiceView
  },
  data: () => ({
    pictures: [
      {
        name: "painting_and_dacor/painting2.jpg",
        title: "Paiting home",
        location: "Mansa"
      },
      {
        name: "painting_and_dacor/painting1.jpg",
        title: "Paiting home",
        location: "Kalulushi"
      }
    ],
    serviceTitle: "Painting",
    serviceDescription:
      "Commercial and residential Plumbing, leak detection and depair, Sink repair, pipe fitting and supply"
  })
};
</script>
